$(window).load(function(){
    $('.ArticleRubis').isotope({
        itemSelector: '.ArticleRuby',
        percentPosition: true,
        masonry: {
            columnWidth: 0
        }
    });
});